<div *ngFor="let msg of messages; index as i; trackBy: _msgid">
  <div *ngIf="msg.type == 'syserror'; else elseFormat">
    <div class="messagebar">
      <div style="float: right">
        <a (click)="dismiss(msg.id)" title="dismiss" style="cursor: pointer"><i 
           class="faa faa-times faa-lg msg-dismiss" style="margin-right: 8px; margin-left: 12px;"></i></a>
      </div>
      <div  [class]="msg.type">
        Oops! {{msg.prefix || defSysErrorPrefix}} {{msg.text}} Please try to edit and save again.
        If problem persists, please contact us at
        <a href="mailto:datasupport@nist.gov?subject=PDR Publishing Error&body={{msg.text}}">datasupport@nist.gov</a>
        to report the problem.
      </div>
    </div>
  </div>
  <ng-template #elseFormat>
  <div class="messagebar">
      <div style="float: right">
        <a (click)="dismiss(msg.id)" title="dismiss" style="cursor: pointer"><i 
           class="faa faa-times faa-lg msg-dismiss" style="margin-right: 8px; margin-left: 12px;"></i></a>
      </div>
      <div [class]="msg.type">{{msg.text}}</div>
    </div>
  </ng-template>
</div>